import React, { useState, useEffect } from "react";
import { Card, Button, Form, InputGroup } from "react-bootstrap";
import Select from "react-select";
import { InputPic } from "../../../../_metronic/_partials/components/utils/InputPic";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { useFormik } from "formik";
import * as yup from "yup";
import { useSelector, shallowEqual } from "react-redux";
import { add as addCampione } from "../../../api/campioni";
import * as apiTarget from "../../../api/target";

// Schema di validazione
const validationSchema = yup.object({
  name: yup
    .string("Inserire un nome valido")
    .required("Inserire un nome valido")
    .min(3, "Minimo tre caratteri")
    .max(50, "Massimo cinquanta caratteri"),
  qta: yup
    .string("Inserire una quantità valida")
    .min(0, "Minimo tre caratteri")
    .max(20, "Massimo venti caratteri"),
  sku: yup
    .string("Inserire uno SKU valido")
    .min(3, "Minimo tre caratteri")
    .max(20, "Massimo venti caratteri")
    .required("Inserire uno SKU valido"),
  description: yup
    .string("Inserire una descrizione valida")
    .notRequired()
    .min(3, "Minimo tre caratteri")
    .max(500, "Massimo cento caratteri"),
  division: yup
    .number("Selezionare un'azienda")
    .positive("Selezionare un'azienda")
    .required("Selezionare un'azienda"),
  quantity: yup
    .number("Inserire una quantità valida")
    .required("Inserire una quantità valida")
    .positive("Inserire una quantità valida"),
  price: yup
    .number("Inserire un priceo valido")
    .required("Inserire un priceo valido")
    .positive("Inserire un priceo valido"),
});

// Azioni e form fields
const actionsMessages = {
  new: "Crea",
  edit: "Modifica",
  removeImage: "Rimuovi Immagine",
  reset: "Reset",
};

const formFields = {
  name: {
    label: "Nome campione",
    placeholder: "Nome campione...",
  },
  sku: {
    label: "SKU",
    sku: "Sku...",
  },
  qta: {
    label: "Qta",
    sku: "Qta",
  },
  description: {
    label: "Descrizione campione",
    placeholder: "Descrizione...",
    rows: 3,
  },
  division: {
    label: "Selezionare azienda",
    placeholder: "Azienda...",
  },
  
  quantity: {
    label: "Quantità per collo",
    placeholder: "Quantità...",
  },
  price: {
    label: "Costo per collo (€)",
    placeholder: "Costo...",
  },
  image: {
    label: "Immagine prodotto",
  },
};

// Toolbar
const Toolbar = ({
  submitCallback,
  resetImmagineCallback,
  resetCallback,
  closeCallback,
  loading,
  alreadyExisting,
}) => {
  return (
    <div>
      <Button
        disabled={loading}
        onClick={submitCallback}
        className="my-1 ml-2 d-inline-flex align-items-center"
      >
        <span className="svg-icon svg-icon-md svg-icon-light-primary">
          <SVG src={toAbsoluteUrl("/media/svg/icons/General/Save.svg")} />
        </span>
        {alreadyExisting ? actionsMessages.edit : actionsMessages.new}
      </Button>

      {resetImmagineCallback && (
        <Button
          disabled={loading}
          onClick={resetImmagineCallback}
          variant="danger"
          className="my-1 ml-2 d-inline-flex align-items-center"
        >
          <span className="svg-icon svg-icon-md svg-icon-light-primary">
            <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
          </span>
          {actionsMessages.removeImage}
        </Button>
      )}

      <Button
        disabled={loading}
        onClick={resetCallback}
        variant="secondary"
        className="my-1 ml-2 d-inline-flex align-items-center"
      >
        <span className="svg-icon svg-icon-md svg-icon-secondary">
          <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Exchange.svg")} />
        </span>
        {actionsMessages.reset}
      </Button>

      <Button
        onClick={closeCallback}
        variant="secondary"
        className="my-1 ml-2 d-inline-flex align-items-center"
      >
        <span className="svg-icon svg-icon-md svg-icon-secondary">
          <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Left 3.svg")} />
        </span>
        Campioni
      </Button>
    </div>
  );
};

export const EditNewCampione = (props) => {
  const [loading, setLoading] = useState(false);
  const [targetOptions, setTargetOptions] = useState([]);
  // User Redux
  const user = useSelector((state) => state.auth.user, shallowEqual);

  // Stato iniziale
  const initialState = {
    id: false,
    name: "",
    qta: "",
    sku: "",
    description: "",
    division: 0,
    quantity: "",
    price: "",
    image: false,
  };

  const alreadyExisting = props.campione !== false;
  if (alreadyExisting) {
    Object.assign(initialState, props.campione);
  }

  // State locali
  const [name, setName] = useState(initialState.name);
  const [qta, setQta] = useState(initialState.qta);
  const [sku, setSku] = useState(initialState.sku);
  const [description, setDescription] = useState(initialState.description);
  const [division, setDivision] = useState(initialState.division);
  const [quantity, setQuantity] = useState(initialState.quantity);
  const [price, setPrice] = useState(initialState.price);
  const [image, setImage] = useState(initialState.image);

  // Reset form
  const handleReset = () => {
    setName(initialState.name);
    setQta(initialState.qta);
    setSku(initialState.sku);
    setImage(initialState.image);
    setDescription(initialState.description);
    setDivision(initialState.division);
    setQuantity(initialState.quantity);
    setPrice(initialState.price);
    formik.handleReset();
  };

  // Formik
  const formik = useFormik({
    initialValues: {
      name: name,
      sku: sku,
      qta: qta,
      description: description,
      division: division,
      quantity: quantity,
      price: price,
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setLoading(true);
      let result = new FormData();

      result.append("id", alreadyExisting ? initialState.id : "");
      result.append("name", values.name);
      result.append("qta", values.qta);
      result.append("sku", values.sku);
      result.append("azienda", values.division);
      result.append("descrizione", values.description);
      result.append("quantity", parseInt(values.quantity));
      result.append("price", parseFloat(values.price));
      result.append("accessToken", user.authToken);

      if (image !== false) result.append("image", image);

      addCampione(result)
        .then(() => {
          setLoading(false);
          props.triggerServerUpdate();
          props.hideEditPage();
        })
        .catch((e) => {
          setSubmitting(false);
          setLoading(false);
          setStatus(e.message);
        });
    },
  });

  // Classi input
  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }
    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }
    return "";
  };

  return (
    <Card className="card-custom gutter-b">
      <Card.Header className="border-0 py-5 row">
        <Card.Title className="float-left col-auto">
          <h3 className="font-weight-bolder text-dark">
            {alreadyExisting
              ? actionsMessages.edit + " campione"
              : actionsMessages.new + " campione"}
          </h3>
        </Card.Title>
        <Toolbar
          submitCallback={formik.handleSubmit}
          resetImmagineCallback={!image ? null : () => setImage(false)}
          resetCallback={handleReset}
          closeCallback={props.hideEditPage}
          loading={loading}
          alreadyExisting={alreadyExisting}
          className="float-right col-auto"
        />
      </Card.Header>
      <Card.Body className="pt-0">
        <Form className="row">
          {formik.status && (
            <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
              <div className="alert-text font-weight-bold">{formik.status}</div>
            </div>
          )}
          <Form.Group className="col-xl-4 col-lg-4 col-sm-12">
            <Form.Label>{formFields.name.label}</Form.Label>
            <Form.Control
              type="text"
              name="name"
              placeholder={formFields.name.placeholder}
              value={name}
              onChange={(e) => setName(e.target.value)}
              className={getInputClasses("name")}
              {...formik.getFieldProps("name")}
            />
            {formik.touched.name && formik.errors.name ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.name}</div>
              </div>
            ) : null}
          </Form.Group>

          <Form.Group className="col-xl-2 col-lg-2 col-sm-12">
            <Form.Label>{formFields.qta.label}</Form.Label>
            <Form.Control
              type="text"
              name="qta"
              placeholder={formFields.qta.placeholder}
              value={qta}
              onChange={(e) => setQta(e.target.value)}
              className={getInputClasses("qta")}
              {...formik.getFieldProps("qta")}
            />
            {formik.touched.qta && formik.errors.qta ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.qta}</div>
              </div>
            ) : null}
          </Form.Group>

          <Form.Group className="col-xl-3 col-lg-3 col-sm-12">
            <Form.Label>{formFields.sku.label}</Form.Label>
            <Form.Control
              type="text"
              name="sku"
              placeholder={formFields.sku.placeholder}
              value={sku}
              onChange={(e) => setSku(e.target.value)}
              className={getInputClasses("sku")}
              {...formik.getFieldProps("sku")}
            />
            {formik.touched.sku && formik.errors.sku ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.sku}</div>
              </div>
            ) : null}
          </Form.Group>

          <Form.Group className="col-xl-3 col-lg-3 col-sm-12">
            <Form.Label>{formFields.quantity.label}</Form.Label>
            <Form.Control
              type="number"
              name="quantity"
              placeholder={formFields.quantity.placeholder}
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
              className={getInputClasses("quantity")}
              {...formik.getFieldProps("quantity")}
            />
            {formik.touched.quantity && formik.errors.quantity ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.quantity}</div>
              </div>
            ) : null}
          </Form.Group>

          <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label>{formFields.price.label}</Form.Label>
            <InputGroup>
              <Form.Control
                type="number"
                name="price"
                placeholder={formFields.price.placeholder}
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                className={getInputClasses("price")}
                {...formik.getFieldProps("price")}
              />
              <InputGroup.Text>€</InputGroup.Text>
            </InputGroup>
            {formik.touched.price && formik.errors.price ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.price}</div>
              </div>
            ) : null}
          </Form.Group>

          <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label>{formFields.division.label}</Form.Label>
            <select
              value={division}
              onChange={(e) => setDivision(e.target.value)}
              name="division"
              className={`form-control ${getInputClasses("division")}`}
              {...formik.getFieldProps("division")}
            >
              <option value="">Seleziona azienda</option>
              <option value={1}>Roypet</option>
              <option value={2}>Roydermal</option>
              <option value={11}>Valderma</option>
            </select>
            {formik.touched.division && formik.errors.division ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.division}</div>
              </div>
            ) : null}
          </Form.Group>

          <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label>{formFields.image.label}</Form.Label>
            <InputPic
              name="productPic"
              id="productPic"
              pic={
                typeof image == "string"
                  ? { name: image.split("/").slice(-1)[0] }
                  : image
              }
              setPic={setImage}
            />
          </Form.Group>

          <Form.Group className="col-12">
            <Form.Label>{formFields.description.label}</Form.Label>
            <Form.Control
              as="textarea"
              name="description"
              placeholder={formFields.description.placeholder}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows={formFields.description.rows}
              style={{ resize: "none" }}
              className={getInputClasses("description")}
              {...formik.getFieldProps("description")}
            />
            {formik.touched.description && formik.errors.description ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.description}</div>
              </div>
            ) : null}
          </Form.Group>
        </Form>
      </Card.Body>
    </Card>
  );
};
